import { type LinkProps } from '@/app/components/navigation/link';
import { PAGE_URL } from '@/app/constants/tailwind';

export const NOT_DISPLAY_CONSENT_PATHS = [
  PAGE_URL,
  '/campaigns',
  '/ssi',
  '/csi',
];

export const LCV_NOT_DISPLAY_CONSENT_PATHS = [
  ...NOT_DISPLAY_CONSENT_PATHS,
  '/register',
];

interface ConsentData {
  title: string;
  link: Omit<LinkProps, 'children'>;
  button: string;
  buttonClose: string;
  onClose?: () => void;
}

export const CONSENT_DATA: ConsentData = {
  title: 'เว็บไซต์นี้ใช้คุกกี้',
  link: {
    href: '/privacy-policy',
    target: '_blank',
    title: 'นโยบายความเป็นส่วนตัว',
  },
  button: 'ปิดหน้าต่าง',
  buttonClose: 'ปิดและยินยอม',
};

export const CONSENT_TRACKING = {
  eventName: 'cookie-click',
  iconClose: 'popup-close',
  buttonClose: 'popup-cookie',
  link: 'privacy-policy',
};
